export interface ErrorButton {
  label: string
  variant?: 'text' | 'outlined' | 'contained'
  onClick?: () => void
}

export interface ErrorEvent {
  message: string
  title?: string
  buttons?: ErrorButton[]
}

type ErrorListener = (error: ErrorEvent) => void

const createPlansLimitErrorEventEmitter = () => {
  let listeners: ErrorListener[] = []

  return {
    emit(error: ErrorEvent) {
      listeners.forEach(listener => listener(error))
    },
    subscribe(listener: ErrorListener) {
      listeners.push(listener)

      return () => {
        listeners = listeners.filter(l => l !== listener)
      }
    }
  }
}

export const PlansLimitErrorEventEmitter = createPlansLimitErrorEventEmitter()
